/**
 * @fileOverview
 * @author Zoltan Toth
 * @version 2.2.0
 */

/**
 * @description
 * Vanilla JavaScript dropdown - a tiny (~600 bytes gzipped) select tag replacement.
 *
 * @class
 * @param {(string|Object)} options.elem - HTML id of the select or the DOM element.
 */
const CustomSelect = options => {
  const elem =
    typeof options.elem === 'string'
      ? document.getElementById(options.elem)
      : options.elem;
  const mainClass = 'c-select__container';
  const titleClass = 'c-select__title';
  const listClass = 'c-select__list o-list-bare';
  const optgroupClass = 'c-select__optgroup';
  const selectedClass = 'is-selected';
  const openClass = 'is-open';
  const selectOpgroups = elem.getElementsByTagName('optgroup');
  const selectOptions = elem.options;
  const optionsLength = selectOptions.length;
  const { lang } = document.documentElement;
  const selectText = lang === 'pl' ? 'Wybierz' : 'Select';
  // let index = 0;

  // creating the pseudo-select container
  const selectContainer = document.createElement('div');

  selectContainer.className = mainClass;

  if (elem.id) {
    selectContainer.id = `custom-${elem.id}`;
  }

  // creating the always visible main button
  const button = document.createElement('button');

  button.className = titleClass;
  button.textContent = selectOptions[0].textContent;

  // creating the UL
  const ul = document.createElement('ul');
  ul.className = listClass;

  /**
   * Toggles the open/close state of the select on title's clicks.
   *
   * @public
   */
  function toggle() {
    ul.classList.toggle(openClass);
    button.classList.toggle(openClass);
  }

  /**
   * Opens the select.
   *
   * @public
   */
  function open() {
    ul.classList.add(openClass);
    button.classList.add(openClass);
  }

  /**
   * Closes the select.
   *
   * @public
   */
  function close() {
    ul.classList.remove(openClass);
    button.classList.remove(openClass);
  }

  /**
   * Handles the clicks on current select.
   *
   * @param {object} e - The item the click occured on.
   */
  function onClick(e) {
    e.preventDefault();

    const t = e.target; // || e.srcElement; - uncomment for IE8

    if (t.className === titleClass) {
      toggle();
    }

    if (t.tagName === 'LI') {
      selectContainer.querySelector(`.${titleClass}`).innerText = t.innerText;
      elem.options.selectedIndex = t.getAttribute('data-index');

      // trigger 'change' event
      const evt = new CustomEvent('change');
      elem.dispatchEvent(evt);

      // highlight the selected
      for (let i = 0; i < optionsLength; i += 1) {
        ul.querySelectorAll('li')[i].classList.remove(selectedClass);
      }
      t.classList.add(selectedClass);

      close();
    }
  }

  /**
   * Generates a list from passed options.
   *
   * @param {object} opts - options for the whole select or for an optgroup.
   */
  function generateOptions(opts) {
    for (let i = 0; i < opts.length; i += 1) {
      const li = document.createElement('li');
      li.className = 'c-select__item o-list-bare__item';
      li.innerText = opts[i].textContent;
      li.setAttribute('data-value', opts[i].value);
      li.setAttribute('data-index', i);

      if (
        selectOptions[elem.selectedIndex].textContent === opts[i].textContent
      ) {
        li.classList.add(selectedClass);
        button.textContent = opts[i].textContent;
        if (opts[i].textContent === '—') {
          button.textContent = selectText;
        }
      }

      ul.appendChild(li);
    }
  }

  // dealing with optgroups
  if (selectOpgroups.length) {
    for (let i = 0; i < selectOpgroups.length; i += 1) {
      const div = document.createElement('div');
      div.innerText = selectOpgroups[i].label;
      div.classList.add(optgroupClass);

      ul.appendChild(div);
      generateOptions(selectOpgroups[i].getElementsByTagName('option'));
    }
  } else {
    generateOptions(selectOptions);
  }

  // appending the button and the list
  selectContainer.appendChild(button);
  selectContainer.appendChild(ul);

  selectContainer.addEventListener('click', onClick);

  // pseudo-select is ready - append it and hide the original
  elem.parentNode.insertBefore(selectContainer, elem);
  elem.style.display = 'none';

  /**
   * Closes the current select on any click outside of it.
   *
   */
  document.addEventListener('click', e => {
    if (!selectContainer.contains(e.target)) close();
  });

  return {
    toggle,
    close,
    open,
  };
};

export default CustomSelect;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/customselect.js